var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@cargomatic/ui';
import { getClassName } from '../../../utils/ui/classes';
const baseClasses = ['block', 'flex-none', 'w-full'];
const TextField = forwardRef((_a, ref) => {
    var { className, style, passEventOnChange, error, onChange, name, dataTestId } = _a, props = __rest(_a, ["className", "style", "passEventOnChange", "error", "onChange", "name", "dataTestId"]);
    function handleChange(e) {
        if (onChange) {
            if (passEventOnChange) {
                onChange(e);
            }
            else {
                onChange(e.target.value);
            }
        }
    }
    const inputClassName = getClassName(baseClasses, {
        'text-red-500': !!error,
    }, className);
    return (React.createElement(Input, Object.assign({ ref: ref, className: inputClassName, onChange: handleChange, name: name, style: style, "data-testid": dataTestId || `textField-${name}` }, props)));
});
TextField.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string, // input autocomplete
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    disabled: PropTypes.bool,
    passEventOnChange: PropTypes.bool,
    error: PropTypes.bool,
    dataTestId: PropTypes.string,
};
TextField.defaultProps = {
    disabled: false,
    passEventOnChange: false,
};
export default TextField;
